import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import i18n, {getTranslationLang, withTypeTranslation} from '../../../../../i18n';

import * as styles from "./style.css";
import {
  createLlamaActiveGroupTemplatesSelector,
  createLlamaActiveGroupTextTemplatesSelector,
  createLlamaActiveTemplateSelector,
  createLlamaShowTemplatesSelector,
  createLlamaTypeSelector, createStickerIdSelector, createStickerItemIdSelector,
  greetingTextSelector
} from "../../../store/create-llama/selectors";
import {
  checkStepValidation,
  setText,
  setTextTemplate,
  setTextTemplatesGroup,
  setThemeGroup
} from "../../../store/create-llama/actions";
import { textTemplatesGroupsSelector } from "../../../store/dictionaries/selectors";
import HorizontalSwitch from "../../../../uq-ui/components/horizontal-switch";
import { createClassNames } from "../../../../../infrastructure/helpers";
import Icon from "../../../../icons/Icon";
import UQButton from "../../../../uq-ui/components/button";
import { StickerCreateStepEnum } from "../../../domain/enums/StickerCreateStepEnum";
import { truncateString } from "../../../../uq-ui/helpers/truncateString";
import Div100vh from "../../../../uq-ui/components/div-100";
import cacheManager from '../../../domain/services/StickerCache';
import { createLlamaStateSelector, createLlamaIdSelector } from "../../../store/create-llama/selectors";
import UserAgent from '../../../../uq-ui/helpers/express-useragent';
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
import StickersComponentsScannerHeader from "../../components/scanner-header";
import { isMemorialType } from "../../../store/sticker-show/selectors";

const userAgent = new UserAgent().parse(navigator.userAgent);
const isMobileSafari = userAgent.isMobile && userAgent.isSafari;
class StickersScreensNewStickerMessage extends PureComponent {

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-new-sticker-message');
    this.props.checkStepValidation(StickerCreateStepEnum.InputMessage);
  }

  onBackPressed = () => {
    const {history, stickerId, stickerItemId} = this.props;
    history.push(`/stickers/${stickerId}/new/preview`);
  };

  onNextPressed = () => {
    const { stickerState, stickerId, stickerItemId} = this.props;
    cacheManager.cacheMessage(stickerState);
    this.props.history.push(`/stickers/${stickerId}/new/preview`);
  };

  onMessageChange = (event) => {
    this.props.setText(event.target.value);
  };

  onTextTemplateGroupPressed = (group) => {
    this.props.setTextTemplatesGroup(group);
    this.props.setThemeGroup(group);
  };

  onTextTemplatePressed = (template) => {
    this.props.setTextTemplate(template);
  };

  isTemplateSelected = (template) => {
    return this.props.selectedTemplate && this.props.selectedTemplate.id === template.id;
  };

  groupKeyExtractor = (item) => item.id;

  groupLabelExtractor = (item) => {
    const text = item.title;
    return text[getTranslationLang()] || text['en'];
  };

  _renderTemplate(template, index) {
    const isSelected = this.isTemplateSelected(template);
    const templateBtnStyle = [styles.templateBtn, styles.templateBtnText];
    if (isSelected) {
      templateBtnStyle.push(styles.templateBtnSelected);
    }

    const templateBtnClass = createClassNames(templateBtnStyle);
    const translatedText = truncateString(template.text, { max: 45 });

    if (!isSelected) {
      return (
        <div key={template.id}
             onClick={() => this.onTextTemplatePressed(template)}
             className={templateBtnClass}
             style={{ border: '1.74px solid #FFFFFF' }}>
          {translatedText}
        </div>
      )
    } else {
      return (
        <div key={template.id}
             onClick={() => this.onTextTemplatePressed(template)}
             className={templateBtnClass}
             style={{ border: '1.74px solid #7B6CE7' }}>
          <div className={styles.selectedItem}>
            <Icon name="CheckedTheme" width="20px" height="20px"/>
          </div>
          {translatedText}
        </div>
      )
    }
  }

  getTemplatesByLang = (lang) => {
    let templates = this.props.activeGroupTemplates.filter((t) => t.lang === lang);
    if (templates.length === 0) {
      templates = this.props.activeGroupTemplates.filter((t) => t.lang === 'en');
    }
    return templates.map((template, index) => this._renderTemplate(template, index));
  };

  renderTemplates = () => {
    if (!this.props.showTemplates) {
      return (<div></div>);
    }

    const listStyle = isMobileSafari && i18n.dir() === 'rtl' ? {scrollSnapType: 'x proximity'} : {};
    return (<div>
      <HorizontalSwitch
        contentContainerStyle={{ marginTop: '20px', paddingBottom: '12px' }}
        containerStyles={{ height: '66px' }}
        items={this.props.textTemplateGroups}
        onPress={this.onTextTemplateGroupPressed}
        keyExtractor={this.groupKeyExtractor}
        labelExtractor={this.groupLabelExtractor}
        selectedItem={this.props.selectedGroup}/>

      {this.props.selectedGroup && (
        <div className={styles.themesScrollList}
             style={listStyle}>
          {this.getTemplatesByLang(getTranslationLang())}
          <div className={styles.themesScrollListSpacer}/>
        </div>
      )}
    </div>)
  };

  render() {
    return (
      <Fragment>
        <StickersComponentsScannerHeader
          theme={ this.props.isMemorialTheme ? 'white' : 'brand' }
          title={this.props.t('headerTitle')}
          showBackBtn={true}
          onBack={this.onBackPressed}/>
        <Div100vh className={ this.props.isMemorialTheme ? styles.scrollView_memorial : styles.scrollView }>
          <div className={styles.top}>
            <div className={styles.header}>
              <div className={`${ this.props.isMemorialTheme ? styles.title_memorial : styles.title } font-title`}
                   dangerouslySetInnerHTML={{__html: this.props.t2(this.props.stickerType,'title')}}/>
            </div>
            <div>
              <div className={styles.textInputContainer}>
                <textarea placeholder={this.props.t2(this.props.stickerType,'textPlaceholder')}
                          className={styles.textInputInner}
                          value={this.props.text}
                          onChange={this.onMessageChange}
                          rows={5}/>
              </div>
            </div>

            {this.renderTemplates()}
          </div>

          <div className={styles.bottom}>
            <UQButton label={this.props.t('doneBtn')}
                      containerStyle={{minWidth: 140}}
                      theme={ this.props.isMemorialTheme ? 'memorial' : 'brand' }
                      onPress={this.onNextPressed}/>
          </div>
        </Div100vh>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stickerId: createStickerIdSelector(state),
    stickerItemId: createStickerItemIdSelector(state),
    stickerState: createLlamaStateSelector(state),
    text: greetingTextSelector(state),
    textTemplateGroups: textTemplatesGroupsSelector(state),
    selectedGroup: createLlamaActiveGroupTextTemplatesSelector(state),
    activeGroupTemplates: createLlamaActiveGroupTemplatesSelector(state),
    selectedTemplate: createLlamaActiveTemplateSelector(state),
    showTemplates: createLlamaShowTemplatesSelector(state),
    stickerType: createLlamaTypeSelector(state),
    isMemorialTheme: isMemorialType(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setThemeGroup: (group) => dispatch(setThemeGroup(group)),
    setText: (value) => dispatch(setText(value)),
    setTextTemplate: (template) => dispatch(setTextTemplate({ template })),
    setTextTemplatesGroup: (group) => dispatch(setTextTemplatesGroup(group)),
    checkStepValidation: (stepEnum) => dispatch(checkStepValidation(stepEnum))
  }
};

export default compose(
  withTranslation('scr-new-sticker-message'),
  connect(mapStateToProps, mapDispatchToProps),
  withTypeTranslation
)(StickersScreensNewStickerMessage);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/new-sticker-message/index.jsx